module.exports = __webpack_public_path__ + "img/two_step.764561db.svg";